import app from './lib/app'

import routes from './src/route/routes'






export const coreRoutes = routes
export default app